<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="sidebar-left w-100">
        <div class="sidebar">
          <div
              class="sidebar-content w-100"
          >
            <!-- Header -->
            <div class="chat-fixed-search w-100">
              <div class="d-flex align-items-center w-100">
                <!-- Search -->
                <b-input-group class="input-group-merge w-100 round">
                  <b-input-group-prepend is-text>
                    <feather-icon
                        icon="SearchIcon"
                        class="text-muted"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                      v-model="searchQuery"
                      placeholder="Поиск..."
                  />
                </b-input-group>
              </div>
            </div>

            <!-- ScrollArea: Chat & Contacts -->
            <vue-perfect-scrollbar
                :settings="perfectScrollbarSettings"
                class="chat-user-list-wrapper list-group w-100 scroll-area"
            >

              <!-- Chats Title -->
              <h4 class="mt-4 chat-list-title">
                Учителя
              </h4>

              <!-- Chats -->
              <ul class="chat-users-list chat-list media-list">
                <li v-for="teacher in teachers"
                    @click="chooseTeacher(teacher.id)"
                    class="chat-info flex-grow-1"
                    :class="{'active': teacher.id === activeTeacher}"
                >
                  <h5 class="mb-0">
                    {{ teacher.name }} - {{ teacher.email }}
                  </h5>
                  <p class="card-text text-truncate">
                  </p>
                </li>
              </ul>
            </vue-perfect-scrollbar>
          </div>

        </div>
      </div>
    </div>
    <div v-if="activeTeacher" class="col-lg-8">
      <h3 class="mb-2">
        {{ teachers.find(teacher => teacher.id === activeTeacher).name }}
      </h3>
      <div class="d-flex mb-4 working-days-wrapper">
        <label class="working_days" :class="{'active': chosenDays.some(cday => +cday === day.id)}"
               v-for="day in days">
          <span>{{ day.name }}</span>
          <input type="checkbox" v-model="chosenDays" :value="day.id">
        </label>
      </div>
      <div class="mb-2">
        <div class="row">
          <div class="col-md-6" :key="day" v-for="(day) in sortedChosenDays">
            <div v-for="workingDay in daysWorkingHoursIntervals[day]" class="d-flex w-100">
              <WorkingHoursInput :key="day" ref="workingHours"
                                 :start-time="workingDay.start ? workingDay.start : ''"
                                 :end-time="workingDay.end ? workingDay.end : ''"
                                 :day-id="day"
                                 :day-name="returnDay(day)"/>
            </div>
            <b-button @click="addWorkingHours(day)" class="mb-3" variant="primary">
              Add working hour
            </b-button>
          </div>
        </div>
      </div>
      <div>

        <b-form-group
            label-for="gbo_notice"
        >
          <b-form-textarea
              placeholder="Описание"
              id="gbo_notice"
              v-model="form.description"
              trim
              class="default-textarea"
          />
          <b-form-invalid-feedback>
            Заполните данное поле
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button @click="scheduleReady" variant="primary">
          Сохранить
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BInputGroup,
  BInputGroupPrepend
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import WorkingHoursInput from "@/components/TeacherSchedule/WorkingHoursInput";
import {createNamespacedHelpers} from 'vuex'
import CRMApi from '@/api/crm';


const {mapState, mapActions} = createNamespacedHelpers('crm')

export default {
  components: {
    WorkingHoursInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    BInputGroupPrepend,
    BFormInput,
    BInputGroup,
    BButton,
    VuePerfectScrollbar
  },
  name: "index",
  computed: {
    ...mapState({
      teachers: state => state.teachers
    }),
    sortedChosenDays() {
      return this.chosenDays.sort((day1, day2) => {
        if (day1 > day2) {
          return 1
        }
        return -1;
      })
    },
  },
  data() {
    return {
      form: {},
      days: [
        {
          id: 0,
          name: 'Понедельник',
        },
        {
          id: 1,
          name: 'Вторик',
        },
        {
          id: 2,
          name: 'Среда'
        },
        {
          id: 3,
          name: 'Четверг'
        },
        {
          id: 4,
          name: 'Пятница',
        },
        {
          id: 5,
          name: 'Суббота'
        },
        {
          id: 6,
          name: 'Воскресенье'
        }
      ],
      chosenDays: [],
      filledTime: {},
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      searchQuery: '',
      activeChatContactId: '',
      activeTeacher: null,
      daysWorkingHoursIntervals: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      },
    }
  },
  methods: {
    ...mapActions(['getUsers']),
    returnDay(id) {
      return this.days[id].name;
    },
    scheduleReady() {
      let options = {
        teacher_id: this.activeTeacher,
        description: this.form.description
      }

      const days = {}
      Array.from(this.$refs.workingHours).forEach(workingHour => {
        if (!days[workingHour.dayId]) {
          days[workingHour.dayId] = [];
        }
        days[workingHour.dayId].push({
          start: workingHour.form.start,
          end: workingHour.form.end,
        })
      })

      options.days = days

      CRMApi.setTeacherWorkingHours(options)
          .then(() => {
            this.$bvToast.toast(this.$t('Рабочее время учителя сохранено!'), {
              title: this.$t('Рабочее время сохранено!'),
              variant: 'success',
              solid: true,
            })
          })
          .catch(() => {
            this.$bvToast.toast(this.$t('Ошибка сервера'), {
              title: this.$t('Ошибка'),
              variant: 'danger',
              solid: true,
            })
          })
      ;

    },
    clearForm() {
      this.form = {};
      this.filledTime = {};
      this.chosenDays = [];
      this.daysWorkingHoursIntervals = {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      }
    },
    chooseTeacher(id) {
      const teacher = this.teachers.find(teacher => teacher.id === id)
      this.activeTeacher = teacher.id
      this.clearForm();
      this.openPrealoder();
      CRMApi.getTeacherSchedule(this.activeTeacher)
          .then(res => {
            if (res.data) {
              this.form.description = res.data.description
              this.form.id = res.data.id
              this.filledTime = {}
              res.data.working_days.forEach(workingDay => {
                this.daysWorkingHoursIntervals[workingDay.day_id].push(workingDay)
                if (this.chosenDays.indexOf(workingDay.day_id) === -1) {
                  this.chosenDays.push(workingDay.day_id);
                }
                this.filledTime[workingDay.day_id] = {
                  start: workingDay.start,
                  end: workingDay.end,
                }
              })
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.closePreloader();
          })
    },
    addWorkingHours(day) {
      this.daysWorkingHoursIntervals[day].push({});
    }
  },
  created() {
    this.getUsers();
  }
}
</script>

<style lang="scss" scoped>
.chat-users-list {
  height: 80vh;
  padding-left: 0;
  list-style-type: none;

  .chat-info {
    padding: 10px;
    cursor: pointer;

    &.active {
      background: #ffbd3b;

      h5 {
        color: #fff;
      }
    }
  }
}

.dark-layout {
  .chat-fixed-search {
    background-color: #283046;
  }

  .chat-user-list-wrapper {
    background-color: #283046;
  }
}

@media (max-width: 767px) {
  .working-days-wrapper{
    flex-wrap: wrap;
  }
}
</style>
